export type NumericWireValue = number | string | null | undefined;

export const toNumber = (value: NumericWireValue, fallback = 0): number => {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }

  const numericValue = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(numericValue) ? numericValue : fallback;
};

export const maybeNumber = (value: NumericWireValue): number | undefined => {
  const numericValue = toNumber(value, Number.NaN);
  return Number.isFinite(numericValue) ? numericValue : undefined;
};

export const formatCurrency = (
  amount: NumericWireValue,
  currency: string = 'NPR',
  fallback: string = `${currency} --`
): string => {
  const numericAmount = maybeNumber(amount);
  if (numericAmount === undefined) {
    return fallback;
  }

  return `${currency} ${numericAmount.toLocaleString('en-IN')}`;
};

export const formatNpr = (
  amount: NumericWireValue,
  fallback: string = 'NPR --'
): string => formatCurrency(amount, 'NPR', fallback);

export const formatAh = (
  amount: NumericWireValue,
  fallback: string = '-- Ah'
): string => {
  const numericAmount = maybeNumber(amount);
  if (numericAmount === undefined) {
    return fallback;
  }

  if (numericAmount > 0 && numericAmount < 0.1) {
    return '<0.1 Ah';
  }

  return `${numericAmount.toFixed(1)} Ah`;
};
